@import '../../../../../constants/spacing.module.less';

.fbs-application-drawer-section {
  border-radius: 8px;
  border: 1px solid var(--grey-300);
  background: var(--white);

  &.is-disabled {
    background: var(--gray-F1F2F3);
  }
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: @space-16;
  padding: @space-24 @space-16;
}

.section-title {
  flex: 1;
}

.section-content {
  padding: @space-0 @space-16 @space-24 @space-48;
}

.edit-button {
  gap: @space-4;
}

.edit-button-icon {
  height: 16px;
  width: 16px;
  padding: 2px; // figma icon padding
}
